import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RoyalDecreeService } from "src/app/core/services/royal-decree.service";
import { CertificatesService } from "./../../services/certificates.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { TokenService } from "src/app/core/services/token.service";
import { CommonService } from "src/app/core/services/common.service";
import { GenericoService } from "src/app/core/services/generico.service";
import { ListValueService } from "src/app/core/services/list-value.service";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { AppConstants } from "src/app/constants/app.constants";
import { FieldElement, SimilarFields, ValidateVehiculo } from "../../models";

@Component({
  selector: "app-resquest-certificate-data",
  templateUrl: "./resquest-certificate-data.component.html",
  styleUrls: ["./resquest-certificate-data.component.scss"],
})
export class ResquestCertificateDataComponent implements OnInit {
  public lastModifiedDate;
  public mensajeSwalPopup;
  public iconSwalPopup;
  public uploadSuccess = false;
  public isGenericAvailable = false;
  public vehiculoValid = false;
  public isAbasico = false;

  public routing = RoutingConstants.certificatesRequest;
  public roles = AppConstants.roles;

  brandsList = [];

  optionsTree = {
    readonly: true,
  };

  solicitudDatos: FormGroup;
  treeData = {
    "Reforma de importancia": null,
    "Otros certificados": null,
  };
  reformsLoaded = false;
  certificatesLoaded = false;
  datosEspecificos = "";
  @ViewChild("confirmSwal")
  public readonly confirmSwal!: SwalComponent;

  files = {
    documentoGenAdjuntar: undefined,
    documentoGenAdicional: undefined,
    documentoAdjuntar: undefined,
    documentoAdicional: undefined,
  };

  filesDatosEspecificos = {};

  fieldsToShow = [];

  selectedGroup = "";

  selectedCerts = [];

  fileDatosEspecificos = [];

  listasInputDatosEspecificos = {};

  requestText: string;
  similarFields: SimilarFields[] = [
    {
      id: "AL_0004",
      type: "text",
      text: "DESCRIPCIÓN REFORMA",
    },
    {
      id: "FI_0001",
      type: "file",
      text: "FICHA ITV",
    },
    {
      id: "FI_0003",
      type: "file",
      text: "CERTIFICADO DE TALLER",
    },
  ];

  public filesListOD: File[] = [];

  constructor(
    private royalDecreeService: RoyalDecreeService,
    private toastrAlertService: ToastrAlertService,
    private sweetAlertService: SweetAlertService,
    private certificatesService: CertificatesService,
    private commonService: CommonService,
    private listValueService: ListValueService,
    private router: Router,
    private translateService: TranslateService,
    private tokenService: TokenService,
    private genericoService: GenericoService
  ) {}

  ngOnInit(): void {
    this.translateService.get("messages.requestText").subscribe(
      (data) => {
        this.requestText = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
    this.checkAbasico();
    this.getGenericoByActiveUser();
    this.initFormGroupIndividual();
    this.getReforms();
    this.getOtherCertificates();
    this.getBrands();
    // create extra fields
    this.loadLists();
  }

  getGenericoByActiveUser() {
    this.genericoService.getGenericoByActiveUser().subscribe(
      (data) => {
        if (data != null && data.geSolictitudActiva == 1) {
          this.isGenericAvailable = true;
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  checkAbasico() {
    let roles = this.tokenService.getRoles();

    if (roles.includes(this.roles.ABASICO)) {
      this.isAbasico = true;
    }
  }

  initFormGroupIndividual() {
    if (this.solicitudDatos) {
      this.solicitudDatos.get("bastidor")?.enable();
      this.solicitudDatos.get("matricula")?.enable();
    }
    this.solicitudDatos = new FormGroup({
      bastidor: new FormControl("", [Validators.required]),
      matricula: new FormControl("", [Validators.required]),
      type: new FormControl("individual", Validators.required),
      peTcId: new FormControl(""),
    });

    this.vehiculoValid = false;
    this.fieldsToShow = [];
  }

  initFormGroupIndividualExtraFields() {
    let fieldList = this.fieldsToShow[1];

    this.addControls(fieldList);
  }

  private addControls(fieldList: any[]) {
    for (let i in fieldList) {
      if (
        !fieldList[i]["ccValorvinculacion"] ||
        fieldList[i]["ccValorvinculacion"] == "N"
      ) {
        let value = fieldList[i]["cdTipo"].includes("LITERAL")
          ? fieldList[i]["cdTexto"]
          : fieldList[i]["cdTipo"].includes("TITLE")
          ? fieldList[i]["cdTexto"]
          : this.checkIfAreSimilarFieldsWithValue(fieldList[i]);

        this.addNewControlToFormGroup(
          this.solicitudDatos,
          fieldList[i]["cdUniqueid"],
          fieldList[i]["cdTipo"],
          value,
          fieldList[i]["ccObligatorio"]
        );
      }
    }
  }

  private checkIfAreSimilarFieldsWithValue(field): string {
    let value: string = "";
    this.similarFields.forEach((similarField) => {
      let fieldsFiltered = this.fieldsToShow[1].filter(
        (fieldShow) =>
          fieldShow.cdId === similarField.id && field.cdId === similarField.id
      );
      if (fieldsFiltered && fieldsFiltered.length > 1) {
        let keys = Object.keys(this.solicitudDatos.controls);

        fieldsFiltered.forEach((element) => {
          if (keys.includes(element.cdUniqueid)) {
            value = this.solicitudDatos.value[element.cdUniqueid];
            if (this.fileDatosEspecificos[element.cdUniqueid])
              this.fileDatosEspecificos[field.cdUniqueid] =
                this.fileDatosEspecificos[element.cdUniqueid];
          }
        });
      }
    });
    return value;
  }

  clearFiles() {
    this.files = {
      documentoGenAdjuntar: undefined,
      documentoGenAdicional: undefined,
      documentoAdjuntar: undefined,
      documentoAdicional: undefined,
    };
  }

  addNewControlToFormGroup(
    formGroup: any,
    uid: any,
    tipo: string,
    value: any,
    required?: boolean
  ) {
    value = tipo.includes("BOOL") ? "no" : value;
    if (required) {
      formGroup.addControl(
        uid,
        new FormControl(value, [Validators.required, Validators.maxLength(256)])
      );
    } else {
      formGroup.addControl(
        uid,
        new FormControl(value, Validators.maxLength(256))
      );
    }
  }

  initFormGroupGeneric() {
    this.solicitudDatos = new FormGroup({
      type: new FormControl("generic", Validators.required),
      documentoGenAdjuntar: new FormControl("", [Validators.required]),
      documentoGenAdicional: new FormControl(""),
      marca: new FormControl(""),
      observaciones: new FormControl(""),
    });
  }

  initFormGroupOtro() {
    this.solicitudDatos = new FormGroup({
      type: new FormControl("otro", Validators.required),
    });
  }

  changeCertificateType(e) {
    if (e.target.value == "generic") {
      this.initFormGroupGeneric();
    } else if (e.target.value == "individual") {
      this.initFormGroupIndividual();
    } else if (e.target.value == "otro") {
      this.initFormGroupOtro();
    }
    this.clearFiles();
  }

  getReforms() {
    this.royalDecreeService.listImportantReform().subscribe(
      (data) => {
        this.buildReformsTree(data);
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getOtherCertificates() {
    this.royalDecreeService.listOtherCertificates().subscribe(
      (data) => {
        this.buildCertificatesTree(data);
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getBrands() {
    this.listValueService.listValuesMarcas().subscribe(
      (data) => {
        this.brandsList = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.documentNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  loadLists() {
    this.listValueService.listAnchoNeumatico().subscribe(
      (data) => {
        this.listasInputDatosEspecificos["NEUMATICO_ANCHO"] = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.documentNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );

    this.listValueService.listPerfilNeumatico().subscribe(
      (data) => {
        this.listasInputDatosEspecificos["NEUMATICO_PERFIL"] = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.documentNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );

    this.listValueService.listIndiceCarga().subscribe(
      (data) => {
        this.listasInputDatosEspecificos["INDICE_CARGA"] = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.documentNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );

    this.listValueService.listSimbolosIndiceVelocidad().subscribe(
      (data) => {
        this.listasInputDatosEspecificos["INDICE_VELOCIDAD"] = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.documentNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );

    this.listValueService.listGargantaNeumatico().subscribe(
      (data) => {
        this.listasInputDatosEspecificos["NEUMATICO_GARGANTA"] = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.documentNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );

    this.listValueService.listDiametroNeumatico().subscribe(
      (data) => {
        this.listasInputDatosEspecificos["NEUMATICO_DIAMETRO"] = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.documentNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
    //
    this.listValueService.listBombeoNeumatico().subscribe(
      (data) => {
        this.listasInputDatosEspecificos["NEUMATICO_BOMBEO"] = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.documentNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );

    this.listValueService.listClasificaciones().subscribe(
      (data) => {
        this.listasInputDatosEspecificos["CLASIFICACIONES"] = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.documentNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  handleFileInputDatosEspecificos(fileInput: any, elementId: any) {
    this.fileDatosEspecificos[elementId] = undefined;
    this.solicitudDatos[elementId] = undefined;

    if (fileInput.target.files && fileInput.target.files[0]) {
      if (
        Array.from(fileInput.target.files).filter(
          (file: File) =>
            file.name.length > AppConstants.maximaLongitudNombreFichero
        ).length > 0
      ) {
        let message = this.translateService.instant(
          "messages.maxFileNameExceeded"
        );
        this.toastrAlertService.toastrFail(message);
        return;
      }

      if (
        Array.from(fileInput.target.files).filter(
          (file: File) => file.size > AppConstants.tamanyoMaximoFicheroEnBytes
        ).length > 0
      ) {
        let message = this.translateService.instant(
          "messages.maxFileSizeExceeded"
        );
        this.toastrAlertService.toastrFail(message);
        return;
      }

      this.solicitudDatos.patchValue({
        [elementId]: fileInput.target.files[0].name,
      });
      let element = this.fieldsToShow[1].find(
        (e) => e.cdUniqueid === elementId
      );
      this.fillSimilarField("text", element);

      const reader = new FileReader();
      reader.onload = (e: any) => {
        let blob = this.commonService.castToBlob(e.target.result);
        this.fileDatosEspecificos[elementId] = blob;
        this.fillSimilarField("file", element, blob);
      };
      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  setCheck(event, id) {
    this.solicitudDatos.patchValue({
      [id]: event.target.value,
    });
    for (let ìterator in this.fieldsToShow[1]) {
      if (this.isVisibleByRadioGroupId(this.fieldsToShow[1][ìterator])) {
        this.addNewControlToFormGroup(
          this.solicitudDatos,
          this.fieldsToShow[1][ìterator]["cdUniqueid"],
          this.fieldsToShow[1][ìterator]["cdTipo"],
          this.fieldsToShow[1][ìterator]["cdTipo"].includes("LITERAL")
            ? this.fieldsToShow[1][ìterator]["cdTexto"]
            : this.fieldsToShow[1][ìterator]["cdTipo"].includes("TITLE")
            ? this.fieldsToShow[1][ìterator]["cdTexto"]
            : "",
          this.fieldsToShow[1][ìterator]["ccObligatorio"]
        );
      } else {
        this.solicitudDatos.removeControl(
          this.fieldsToShow[1][ìterator]["cdUniqueid"]
        );
      }
    }
  }

  isVisibleByRadioGroupId(element) {
    if (!element["ccValorvinculacion"]) {
      return true;
    } else {
      let field = this.fieldsToShow[1].find(
        (e) =>
          e.cdReforma == element.cdReforma && e.cdId == element.ccCampovinculado
      );
      if (
        (element["ccValorvinculacion"] == "N" &&
          this.solicitudDatos.value[field?.cdUniqueid] == "no") ||
        (element["ccValorvinculacion"] == "S" &&
          this.solicitudDatos.value[field?.cdUniqueid] == "si")
      ) {
        return true;
      } else {
        return false;
      }
    }
  }

  buildReformsTree(data) {
    let node = new Object();
    let parents = data.filter((e) => e.padre == null && e.reTramitable);
    parents.forEach((element) => {
      let arrayChilds = [];
      let childs = data.filter((item) => item.padre == element.reId);
      if (childs && childs.length > 0) {
        childs.forEach((element) => {
          if (element.reTramitable) {
            arrayChilds.push(element.reId + " - " + element.reDescr);
          }
        });
      }
      node[element.reId + " - " + element.reDescr] =
        arrayChilds.length == 0 ? null : arrayChilds;
    });
    this.treeData["Reforma de importancia"] = node;
    this.reformsLoaded = true;
  }

  buildCertificatesTree(data) {
    let arrayChilds = [];
    data.forEach((e) => {
      if (
        e.tcId != "CC" &&
        e.tcId != "CM" &&
        e.tcId != "CML" &&
        e.tcId != "PL" &&
        e.tcId != "PLH" &&
        e.tcId != "PLI" &&
        e.tcId != "GE" &&
        e.tcId != "OD" &&
        e.tcId != "RE"
      ) {
        arrayChilds.push(e.tcId + " - " + e.tcDescr);
      }
    });
    this.treeData["Otros certificados"] = arrayChilds;
    this.certificatesLoaded = true;
  }

  itemSelected(value: any) {
    this.resetForm();

    if (value && value.root && value.root.item && value.child) {
      let maintenancePeticionesDto;
      let peTcId = value.child?.split("-")[0].trim();

      this.solicitudDatos.patchValue({ peTcId: peTcId });
      this.files.documentoAdjuntar = undefined;
      this.selectedGroup = value.root.item;
      this.selectedCerts = [value.child];
      this.sweetAlertService.sweetAlertLoading();

      if (value.root) {
        maintenancePeticionesDto = {
          peticionesDto: {
            peBastidor: this.solicitudDatos.getRawValue().bastidor,
            peMatricula: this.solicitudDatos.getRawValue().matricula,
            peReId: "",
            peTcId: peTcId,
          },
        };

        this.onIndividualCertOtros(maintenancePeticionesDto);
      }
    }
  }

  private loadTMotorAndCategorias() {
    // Load TMotor
    if (this.solicitudDatos.getRawValue().bastidor) {
      this.listValueService
        .listMotores(this.solicitudDatos.getRawValue().bastidor.toUpperCase())
        .subscribe(
          (data) => {
            this.listasInputDatosEspecificos["TMOTOR"] = data[0];
            if (data && data.length == 0) {
              let message = this.translateService.instant(
                "messages.documentNotFound"
              );
              this.toastrAlertService.toastrWarning(message);
            }
          },
          (err) => {
            this.toastrAlertService.toastrFail(err.error.mensaje);
          }
        );
    }
    this.listValueService.listCategorias().subscribe(
      (data) => {
        this.listasInputDatosEspecificos["CATEGORIAS"] = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  public reinitForm() {
    this.solicitudDatos.patchValue({
      bastidor: "",
      matricula: "",
    });
    this.vehiculoValid = false;
    this.solicitudDatos.get("bastidor")?.enable();
    this.solicitudDatos.get("matricula")?.enable();
  }

  public validateVehiculo() {
    let invalidFields = this.commonService.findInvalidControls(
      this.solicitudDatos.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
    } else {
      this.solicitudDatos.patchValue({
        bastidor: this.solicitudDatos.getRawValue().bastidor,
        matricula: this.solicitudDatos.getRawValue().matricula,
      });
      const dto: ValidateVehiculo = {
        bastidor: this.solicitudDatos.getRawValue().bastidor,
        matricula: this.solicitudDatos.getRawValue().matricula,
      };
      this.sweetAlertService.sweetAlertLoading();
      this.certificatesService.validateVehiculoBastidor(dto).subscribe(
        (data) => {
          this.vehiculoValid = true;
          this.solicitudDatos.get("bastidor")?.disable();
          this.solicitudDatos.get("matricula")?.disable();
          this.sweetAlertService.sweetAlertClose();
        },
        (err) => {
          this.toastrAlertService.toastrFail(
            err.error.mensaje
              ? err.error.mensaje
              : "Error al validar el bastidor y matricula"
          );
          this.sweetAlertService.sweetAlertClose();
        }
      );
    }
  }

  itemsSelected(value: any) {
    this.files.documentoAdjuntar = undefined;
    let reformsSelected: string[] = value.child?.split("__");
    let peTcId: string = "";
    if (reformsSelected.length > 0) {
      reformsSelected.sort((a, b) => {
        return parseFloat(a) - parseFloat(b);
      });
      reformsSelected.forEach((e, index) => {
        if (index == 0) {
          peTcId = e;
        } else {
          peTcId += "__" + e;
        }
      });
    }
    this.solicitudDatos.patchValue({ peTcId: peTcId });
    this.resetFormAndKeepDataOfReforms();
    this.selectedGroup = value.root.item;
    this.selectedCerts = value.sGroup?.split(" | ");
    let maintenancePeticionesDto;
    this.sweetAlertService.sweetAlertLoading();
    if (value.root) {
      maintenancePeticionesDto = {
        peticionesDto: {
          peBastidor: this.solicitudDatos.getRawValue().bastidor.trim(),
          peMatricula: this.solicitudDatos.getRawValue().matricula.trim(),
          peReId: peTcId,
          peTcId: "RE",
        },
      };
      this.onIndividualCertRef(maintenancePeticionesDto);
    }
  }

  valueSelectorDatosEspecificos(event: any, field: any) {
    if (event.item != undefined) {
      this.solicitudDatos.patchValue({
        [field]: event.item[event.id],
      });
    } else {
      this.solicitudDatos.patchValue({
        [field]: "",
      });
    }
  }

  valueSelectorMarca(event: any, field: any) {
    if (event.item != undefined) {
      this.solicitudDatos.patchValue({
        marca: event.item[event.id],
      });
    }
  }

  handleFileInputAdjuntar(fileInput: any) {
    this.files.documentoGenAdjuntar = undefined;
    this.solicitudDatos["documentoGenAdjuntar"] = undefined;

    if (fileInput.target.files && fileInput.target.files[0]) {
      if (
        Array.from(fileInput.target.files).filter(
          (file: File) =>
            file.name.length > AppConstants.maximaLongitudNombreFichero
        ).length > 0
      ) {
        let message = this.translateService.instant(
          "messages.maxFileNameExceeded"
        );
        this.toastrAlertService.toastrFail(message);
        return;
      }

      if (
        Array.from(fileInput.target.files).filter(
          (file: File) => file.size > AppConstants.tamanyoMaximoFicheroEnBytes
        ).length > 0
      ) {
        let message = this.translateService.instant(
          "messages.maxFileSizeExceeded"
        );
        this.toastrAlertService.toastrFail(message);
        return;
      }

      this.files.documentoGenAdjuntar = fileInput.target.files[0].name;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        let blob = this.commonService.castToBlob(e.target.result);
        this.solicitudDatos.patchValue({
          documentoGenAdjuntar: blob,
        });
      };
      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  handleFileInputAdicional(fileInput: any) {
    this.files.documentoGenAdicional = undefined;
    this.solicitudDatos["documentoGenAdicional"] = undefined;

    if (fileInput.target.files && fileInput.target.files[0]) {
      if (
        Array.from(fileInput.target.files).filter(
          (file: File) =>
            file.name.length > AppConstants.maximaLongitudNombreFichero
        ).length > 0
      ) {
        let message = this.translateService.instant(
          "messages.maxFileNameExceeded"
        );
        this.toastrAlertService.toastrFail(message);
        return;
      }

      if (
        Array.from(fileInput.target.files).filter(
          (file: File) => file.size > AppConstants.tamanyoMaximoFicheroEnBytes
        ).length > 0
      ) {
        let message = this.translateService.instant(
          "messages.maxFileSizeExceeded"
        );
        this.toastrAlertService.toastrFail(message);
        return;
      }

      this.files.documentoGenAdicional = fileInput.target.files[0].name;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        let blob = this.commonService.castToBlob(e.target.result);
        this.solicitudDatos.patchValue({
          documentoGenAdicional: blob,
        });
      };
      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }
  //
  onGenericCert() {
    this.mensajeSwalPopup = undefined;
    this.iconSwalPopup = undefined;

    if (this.solicitudDatos.value.documentoGenAdjuntar) {
      this.sweetAlertService.sweetAlertLoading();
      this.certificatesService
        .uploadCertGenerico(this.solicitudDatos, this.files)
        .subscribe(
          (data) => {
            this.confirmSwal.html = data["mensaje"];
            this.confirmSwal.fire();
            this.sweetAlertService.sweetAlertClose();
          },
          (err) => {
            let mensaje = this.mensajeDeErrorCargandoArchivo(err);
            this.toastrAlertService.toastrFail(mensaje);
            this.sweetAlertService.sweetAlertClose();
          }
        );
    } else {
      this.toastrAlertService.toastrFail("No archivo encontrado");
    }
  }

  mensajeDeErrorCargandoArchivo(err) {
    let mensaje = "Error cargando archivo. Consulte con su administrador.";
    if (err.error != null && err.error.mensaje != null) {
      mensaje = err.error.mensaje;
    }
    return mensaje;
  }

  onIndividualCertRef(maintenancePeticionesDto: any) {
    this.mensajeSwalPopup = undefined;
    this.iconSwalPopup = undefined;

    this.certificatesService
      .reformasCertificados(maintenancePeticionesDto)
      .subscribe(
        (data) => {
          this.loadTMotorAndCategorias();
          this.solicitudDatos.value.peTcId?.split("__").forEach((element) => {
            this.listValueService
              .listDenominaciones(
                this.solicitudDatos.getRawValue().bastidor.toUpperCase(),
                "RE",
                element,
                ""
              )
              .subscribe(
                (dataDenom) => {
                  if (dataDenom.length > 0) {
                    this.listasInputDatosEspecificos["TCAMBIO_DENOM"] =
                      dataDenom;
                  } else {
                    this.listasInputDatosEspecificos["TCAMBIO_DENOM"] = [];
                  }
                },
                (err) => {
                  this.toastrAlertService.toastrFail(
                    this.mensajeDeErrorCargandoArchivo(err)
                  );
                }
              );
            //

            this.listValueService
              .listSiglas(
                this.solicitudDatos.getRawValue().bastidor.toUpperCase(),
                "RE",
                element,
                ""
              )
              .subscribe(
                (dataSiglas) => {
                  if (dataSiglas.length > 0) {
                    this.listasInputDatosEspecificos["TCAMBIO_SIGLA"] =
                      dataSiglas;
                  } else {
                    this.listasInputDatosEspecificos["TCAMBIO_SIGLA"] = [];
                  }
                },
                (err) => {
                  this.toastrAlertService.toastrFail(
                    this.mensajeDeErrorCargandoArchivo(err)
                  );
                }
              );
          });

          if (data[0]["peReId"].indexOf("__") != -1) {
            data[0]["peOtrasReformas"] = data[0]["peReId"].substring(
              data[0]["peReId"].indexOf("__") + 2
            );
            data[0]["peReId"] = data[0]["peReId"].substr(
              0,
              data[0]["peReId"].indexOf("__")
            );
          }

          let newData = [data[0], []];

          this.selectedCerts.forEach((groupName, index) => {
            newData[1].push({
              cdId: "GRUPO",
              cdAyuda: null,
              cdAyudaB: null,
              cdListadb: null,
              cdLongitud: null,
              cdTexto: groupName,
              cdTipo: "TITLE",
              ccObligatorio: 0,
              ccPosicion: 6,
              ccCampovinculado: null,
              ccValorvinculacion: null,
              cdReforma: groupName.split(" - ")[0],
              cdUniqueid: "RE" + groupName.split(" - ")[0] + "N0",
            });
            data[1]
              .filter((obj) => obj.cdReforma === groupName.split(" - ")[0])
              .forEach((element) => {
                if (element.cdId !== "TEXTO") {
                  newData[1].push(element);
                }
              });
          });

          this.initListFieldsLI(data);

          this.sweetAlertService.sweetAlertClose();
          newData = this.sortByReforma(newData);
          this.fieldsToShow = newData;

          this.initFormGroupIndividualExtraFields();
        },
        (err) => {
          this.sweetAlertService.sweetAlertClose();
          this.toastrAlertService.toastrFail(
            this.mensajeDeErrorCargandoArchivo(err)
          );
        }
      );
    this.solicitudDatos.patchValue({
      documentoAdjuntar: null,
    });
    this.files.documentoAdjuntar = null;
  }

  private convierteStrCodigoReformaEnFloat(strCodigoReforma: string): number {
    let floatCodigoReforma: number = 0.0;
    if (strCodigoReforma == null) return floatCodigoReforma;
    if (strCodigoReforma.trim().length == 0) return floatCodigoReforma;

    let reform = strCodigoReforma.split(".");
    if (reform.length > 1 && reform[1].trim().length == 1)
      strCodigoReforma = reform[0] + ".0" + reform[1].trim();

    floatCodigoReforma = parseFloat(strCodigoReforma);
    return floatCodigoReforma;
  }

  private sortByReforma(data: any[]): any[] {
    if (data.length > 1) {
      data[1].sort((a, b) => {
        const comparacionReforma =
          this.convierteStrCodigoReformaEnFloat(a.cdReforma) -
          this.convierteStrCodigoReformaEnFloat(b.cdReforma);

        // Si dpReforma es el mismo, ordena por ccPosicion
        if (
          comparacionReforma === 0 &&
          a.ccPosicion != null &&
          b.ccPosicion != null
        ) {
          if (a.cdTipo == "TITLE") {
            return -1;
          } else if (b.cdTipo == "TITLE") {
            return 1;
          } else {
            return a.ccPosicion - b.ccPosicion;
          }
        }

        return comparacionReforma;
      });
    }

    return data;
  }

  onIndividualCertOtros(maintenancePeticionesDto: any) {
    this.mensajeSwalPopup = undefined;
    this.iconSwalPopup = undefined;

    this.certificatesService
      .otrosCertificados(maintenancePeticionesDto)
      .subscribe(
        (data) => {
          let newData = [data[0], []];
          this.selectedCerts.forEach((groupName) => {
            newData[1].push({
              cdId: "GRUPO",
              cdAyuda: null,
              cdAyudaB: null,
              cdListadb: null,
              cdLongitud: null,
              cdTexto: groupName,
              cdTipo: "TITLE",
              ccObligatorio: 0,
              ccPosicion: 6,
              ccCampovinculado: null,
              ccValorvinculacion: null,
              cdReforma: groupName.split(" - ")[0],
              cdUniqueid: groupName.split(" - ")[0] + "N0",
            });
            data[1].forEach((element) => {
              if (element.cdId !== "TEXTO") {
                newData[1].push(element);
              }
            });
          });

          this.sweetAlertService.sweetAlertClose();
          this.fieldsToShow = newData;
          this.resetForm();
          this.addControls(this.fieldsToShow[1]);
        },
        (err) => {
          this.sweetAlertService.sweetAlertClose();
          this.toastrAlertService.toastrFail(
            this.mensajeDeErrorCargandoArchivo(err)
          );
        }
      );
    this.solicitudDatos.value.documentoAdjuntar = null;
    this.solicitudDatos.patchValue({
      documentoAdjuntar: null,
    });
    this.files.documentoAdjuntar = null;
  }

  private resetForm() {
    let peTcId = this.solicitudDatos.value.peTcId;
    this.solicitudDatos = new FormGroup({
      bastidor: new FormControl(
        this.solicitudDatos.getRawValue().bastidor.toUpperCase(),
        [Validators.required]
      ),
      matricula: new FormControl(
        this.solicitudDatos.getRawValue().matricula.toUpperCase(),
        [Validators.required]
      ),
      type: new FormControl("individual", Validators.required),
      peTcId: new FormControl(peTcId),
    });
  }

  private resetFormAndKeepDataOfReforms() {
    let peTcId = this.solicitudDatos.value.peTcId;
    this.solicitudDatos.patchValue({
      bastidor: this.solicitudDatos.getRawValue().bastidor.toUpperCase(),
      matricula: this.solicitudDatos.getRawValue().matricula.toUpperCase(),
      type: "individual",
      peTcId: peTcId,
    });
    let reforms: string[] = peTcId.split("__");

    Object.keys(this.solicitudDatos.controls).forEach((key) => {
      if (
        key !== "bastidor" &&
        key !== "matricula" &&
        key !== "type" &&
        key !== "peTcId"
      ) {
        const condition = (element) => key.includes(element);
        if (!reforms.some(condition)) {
          this.solicitudDatos.removeControl(key);
          if (this.fileDatosEspecificos[key])
            delete this.fileDatosEspecificos[key];
        }
      }
    });
  }

  onDatosEspecificos() {
    this.mensajeSwalPopup = undefined;
    this.iconSwalPopup = undefined;
    if (
      this.fieldsToShow.length == 0 &&
      this.fileDatosEspecificos.length == 0
    ) {
      this.toastrAlertService.toastrFail(
        "Es necesario seleccionar un tipo de certificado"
      );
    } else {
      let listaFieldsFileType = [];
      for (let item in this.fieldsToShow[1]) {
        if (this.fieldsToShow[1][item]["cdTipo"] == "FILE") {
          listaFieldsFileType.push(this.fieldsToShow[1][item]);
        }
      }

      if (
        Object.values(this.fileDatosEspecificos).filter(
          (file) =>
            file &&
            file.size &&
            file.size > AppConstants.tamanyoMaximoFicheroEnBytes
        ).length > 0
      ) {
        this.toastrAlertService.toastrFail(
          "Error cargando archivo. No se pueden cargar archivos de más de 5MB."
        );
        return;
      }
      this.sweetAlertService.sweetAlertLoading();
      this.certificatesService
        .datosEspecificos(
          this.solicitudDatos,
          listaFieldsFileType,
          this.fieldsToShow[0],
          this.fieldsToShow[1],
          this.fileDatosEspecificos
        )
        .subscribe(
          (data) => {
            this.confirmSwal.html = data["mensaje"];
            this.confirmSwal.fire();
            this.sweetAlertService.sweetAlertClose();
          },
          (err) => {
            this.toastrAlertService.toastrFail(
              err.error.mensaje ? err.error.mensaje : "Error response"
            );
            this.sweetAlertService.sweetAlertClose();
          }
        );
      this.solicitudDatos.value.documentoAdjuntar = null;
      this.files.documentoAdjuntar = null;
    }
  }

  public onFileOther(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      let isValid = true;
      let newFiles = Array.from(input.files);
      newFiles.forEach((file: File) => {
        isValid = isValid ? this.validateFile(file) : false;
        if (!isValid) {
          newFiles = [];
        }
      });
      const numFiles = this.filesListOD.length + newFiles.length;
      const maxNumFiles = 10;
      if (numFiles > maxNumFiles) {
        let message = this.translateService.instant(
          "messages.maxNumFileExceeded"
        );
        this.toastrAlertService.toastrFail(message);
      } else {
        this.filesListOD = [...this.filesListOD, ...newFiles];
      }
    }
  }

  private validateFile(file: File): boolean {
    if (file.name.length > AppConstants.maximaLongitudNombreFichero) {
      let message = this.translateService.instant(
        "messages.maxFileNameExceeded"
      );
      this.toastrAlertService.toastrFail(message);
      return false;
    }
    if (file.type !== "application/pdf") {
      let message = this.translateService.instant("messages.onlyPdfIsAlowed");
      this.toastrAlertService.toastrFail(message);
      return false;
    }
    return true;
  }

  public removeFilesOD(index?: number) {
    if (index != undefined) {
      this.filesListOD.splice(index, 1);
    } else {
      this.filesListOD = [];
    }
  }

  onuploadOther() {
    this.sweetAlertService.sweetAlertLoading();
    this.certificatesService.uploadOtherDocuments(this.filesListOD).subscribe(
      (data) => {
        let text =
          "Los identificadores asignados de las peticiones son: </br> ";
        this.confirmSwal.html = text + data.join("</br>");
        this.confirmSwal.fire();
        this.sweetAlertService.sweetAlertClose();
      },
      (err) => {
        this.sweetAlertService.sweetAlertClose();
        this.toastrAlertService.toastrFail(
          this.mensajeDeErrorCargandoArchivo(err)
        );
      }
    );
  }
  //
  onSave() {
    let invalidFields = this.commonService.findInvalidControls(
      this.solicitudDatos.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
    } else {
      if (this.solicitudDatos.value.type == "generic") {
        this.onGenericCert();
      } else if (this.solicitudDatos.value.type == "individual") {
        this.onDatosEspecificos();
      } else if (this.solicitudDatos.value.type == "otro") {
        this.onuploadOther();
      }
    }
  }

  goList() {
    this.router.navigate([this.routing.list]);
  }

  createAnotherRequest() {
    window.location.reload();
  }

  changeUpperCaseOnly(e) {
    e.target.value = e.target.value.toUpperCase();
  }

  public fillSimilarField(
    type: string,
    element: FieldElement,
    file?: any
  ): void {
    let fieldSimilar;
    switch (type) {
      case "text":
        fieldSimilar = this.similarFields.find(
          (item) => item.id === element.cdId
        );
        if (fieldSimilar) {
          let itemsToSave = this.fieldsToShow[1].filter(
            (e) => e.cdId === element.cdId
          );
          if (itemsToSave && itemsToSave.length > 0) {
            let value = this.solicitudDatos.value[element.cdUniqueid];
            itemsToSave.forEach((e) => {
              this.solicitudDatos.patchValue({
                [e.cdUniqueid]: value,
              });
            });
          }
        }
        break;
      case "file":
        fieldSimilar = this.similarFields.find(
          (item) => item.id === element.cdId
        );
        if (fieldSimilar) {
          let itemsToSave = this.fieldsToShow[1].filter(
            (e) => e.cdId === element.cdId
          );
          itemsToSave.forEach((e) => {
            this.fileDatosEspecificos[e.cdUniqueid] = file;
          });
        }
        break;
      default:
        break;
    }
  }

  private initListFieldsLI(data: any[]) {
    let fields = data[1];
    fields.forEach((element) => {
      if (element.cdTipo === "LIST") {
        this.loadListCamposLI(element.cdId);
      }
    });
  }

  private loadListCamposLI(id: string): void {
    this.listValueService.listCamposLI(id).subscribe(
      (data) => {
        this.listasInputDatosEspecificos[id] = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.documentNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  public getInfoOfACCFields(element: any) {
    let value = this.solicitudDatos.value[element.cdUniqueid];
    this.certificatesService.getInfoOfACCFields(value).subscribe(
      (data) => {
        this.toastrAlertService.toastrInfo(data.mensaje);
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  public setNumber(field) {
    if (
      this.solicitudDatos.value[field] &&
      this.solicitudDatos.value[field] < AppConstants.minNumPuertas
    ) {
      let message =
        document.getElementById(field).textContent +
        this.translateService.instant("messages.numeroMinInt");
      this.toastrAlertService.toastrFail(message);
      this.solicitudDatos.patchValue({
        [field]: AppConstants.defaultNumPuertas,
      });
    }
  }
}
